import { v4 as uuidv4 } from "uuid";
import { trackEventNext } from "../next";
import { Meta } from "../tagmanager";

function PageviewEventsBuilder() {
  function sendPageView(payload?: { user_id: string | null }) {
    const uuid = uuidv4();

    trackEventNext({
      event: "Page Visited",
      user_id: payload?.user_id as string,
      kunduz_event_id: uuid,
    });

    window.gtag({
      event: "page_view",
      page_title: document.title,
      page_location: window.location.pathname,
      user_id: payload?.user_id as string,
      kunduz_event_id: uuid,
    });

    return uuid;
  }

  function sendPageViewWithEventName(
    eventName: string,
    payload?: Meta.ViewContentPayload,
  ) {
    const uuid = uuidv4();

    window.gtag({
      event: eventName,
      ...payload,
      kunduz_event_id: uuid,
    });

    return uuid;
  }

  return Object.freeze({ sendPageView, sendPageViewWithEventName });
}

export const PageviewEvents = PageviewEventsBuilder();
